import React from 'react'
import { PiInstagramLogoThin } from "react-icons/pi";
import { FaFacebookSquare } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";
import { RiArrowRightDoubleLine } from "react-icons/ri";
import { Link } from 'react-router-dom';
import { CiMail } from "react-icons/ci";
import { CiLocationOn } from "react-icons/ci";
import { MdLocalPhone } from "react-icons/md";

import './footer.css'
const Footer = () => {
  return (
    <>
        <div className="footer">
            <div className="footer-container">
                <div className="footer-logo">
                    <h2>ATALOJMAN</h2>
                </div>
                <div className="footer-quick-links">
                    <h4>Hızlı Linkler</h4>
                    <ul className="footer-menu">
                        <Link to="/"> 
                            <div className="footer-menu-items">
                                <i><RiArrowRightDoubleLine/></i>
                                <li>Anasayfa</li>
                            </div>
                        </Link>
                        <Link to="/hakkimizda">
                            <div className="footer-menu-items">
                                <i><RiArrowRightDoubleLine/></i>
                                <li>Hakkımızda</li>
                            </div>
                        </Link>
                        <Link to="/yonetim">
                            <div className="footer-menu-items">
                                <i><RiArrowRightDoubleLine/></i>
                                <li>Yönetim</li>
                            </div>
                        
                        </Link>
                        <Link to="/calisanlar">
                            <div className="footer-menu-items">
                               <i><RiArrowRightDoubleLine/></i>
                                <li>Çalışanlar</li>
                            </div>
                        </Link>
                        <Link to="/hizmetlerimiz">
                            <div className="footer-menu-items">
                                <i><RiArrowRightDoubleLine/></i>
                                <li>Hizmetlerimiz</li>
                            </div>
                        </Link>
                        <Link to="/destek">
                            <div className="footer-menu-items">
                                <i><RiArrowRightDoubleLine/></i>
                                <li>Destek</li>
                            </div>
                        </Link>
                        <Link to="/iletisim">
                         <div className="footer-menu-items">
                                <i><RiArrowRightDoubleLine/></i>
                                <li>İletişim</li>
                            </div>
                        </Link>
                    </ul>
                </div>
                <div className="footer-contact-info">
                    <div className="footer-contact-us">
                    <div className="footer-contact-us-header">
                            <h4>Bize Ulaşın</h4>
                        </div>
                        <div className="footer-contact-us-list">
                        <div className="footer-mail">
                        <div className="footer-icon-wrap">
                        <span><CiMail/></span>
                        <span>E-Posta :</span>
                        </div>
                        <p>ataunilojmanlari@gmail.com </p>
                    </div>
                    <div className="footer-phone">
                    <div className="footer-icon-wrap">
                        <span><MdLocalPhone/></span>
                        <span>Telefon : </span>
                        </div>
                        <p>0 (442) 231 1273</p>
                    </div>
                    <div className="footer-address">
                    <div className="footer-icon-wrap">
                        <span><CiLocationOn/></span>
                        <span>Adres :</span>
                        </div>
                        <p>Atatürk Üniversitesi Lojman Site Yönetim Kurulu Başkanlığı, Üniversite Lojmanları YÖK Lojmanları B Blok Yakutiye Erzurum</p>
                    </div>
                        </div>
                    </div>
                    <div className="footer-social-accounts">
                        <div className="footer-social-header">
                            <h4>Sosyal Medya</h4>
                        </div>
                        <div className="footer-social-icons">
                            <ul>
                                <li><PiInstagramLogoThin /></li>
                                <li><FaFacebookSquare /></li>
                                <li><FaXTwitter /></li>
                                <li><FaLinkedin /></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
         
        <div className="footer-copy-right">
           <div className="copy-right">
              <p>Copyright  2025,  Atatürk Üniversitesi Lojmanlar</p>
           </div>
           <div className="footer-creater">
            <p>ALPEREN ILGAZ tarafından geliştirilmiştir</p>
           </div>
          
        </div>
        
        </div>
    </>
  )
}

export default Footer